import { showStatus } from './AxiosReqs';

export let Features = [];
export let Specs = [];

const renderFeatures = function (featureList) {
  const featureHtml = Features.map((feature) => {
    return `<li>
      <p class="feature-el">${feature} <span class="rem-feature">❌</span></p>
    </li>`;
  }).join('');

  featureList.innerHTML = featureHtml;
};

export const addFeature = function (featureList) {
  const addBtn = document.querySelector('.feature-add');

  // Add feature
  addBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (Features.length === 5)
      return showStatus('fail', 'Max 5 features allowed');

    const featureInp = document.getElementById('features');
    const featureText = featureInp.value.trim();

    if (!featureText) return;

    Features.push(featureText);
    renderFeatures(featureList);
    featureInp.value = '';
  });

  // Remove feature (delegation)
  featureList.addEventListener('click', (e) => {
    if (e.target.classList.contains('rem-feature')) {
      const p = e.target.closest('p.feature-el');
      const text = p.textContent.replace('❌', '').trim();

      Features = Features.filter((el) => el !== text);

      renderFeatures(featureList);
    }
  });
};

// * SPECS
const renderSpecs = function (specsList) {
  const specsHtml = Specs.map((spec) => {
    return `<li>
      <p class="spec-el">${spec.key} : ${spec.value} <span class="rem-spec">❌</span></p>
    </li>`;
  }).join('');

  specsList.innerHTML = specsHtml;
};

export const addSpec = function (specsList) {
  const addBtn = document.querySelector('.spec-add');
  addBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (Specs.length === 10) return showStatus('fail', 'Max 10 specs allowed');
    const key = document.querySelector('#specs');
    const value = document.querySelector('#specs-key');
    Specs.push({ key: key.value, value: value.value });
    key.value = '';
    value.value = '';

    renderSpecs(specsList);
  });

  // Remove feature (delegation)
  specsList.addEventListener('click', (e) => {
    if (e.target.classList.contains('rem-spec')) {
      const p = e.target.closest('p.spec-el');
      const text = p.textContent.split(':')[0].trim();

      Specs = Specs.filter((el) => el.key !== text);

      renderSpecs(specsList);
    }
  });
};
